<template>
  <div class="scrolling-block">
    <div class="spec-button" v-if="showLeftArrow" @click="scrollLeft">&laquo;</div>
    <div class="block-container" ref="blockContainer" @scroll="checkScroll">
      <slot></slot>
    </div>
    <div class="spec-button" v-if="showRightArrow" @click="scrollRight">&raquo;</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showLeftArrow: false,
      showRightArrow: true,
    };
  },
  methods: {
    scrollLeft() {
      const blockContainer = this.$refs.blockContainer;
      blockContainer.scrollLeft -= 50;
      this.checkScroll();
    },
    scrollRight() {
      const blockContainer = this.$refs.blockContainer;
      blockContainer.scrollLeft += 50;
      this.checkScroll();
    },
    checkScroll() {
      const blockContainer = this.$refs.blockContainer;
      this.showLeftArrow = blockContainer.scrollLeft > 0;
      this.showRightArrow = blockContainer.scrollLeft < blockContainer.scrollWidth - blockContainer.clientWidth;
    }, 
  },
  updated() {
    this.checkScroll();
  },  
  mounted() {
    window.addEventListener('resize', this.checkScroll);
    this.checkScroll();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScroll);
  },  
};
</script>

<style scoped>
.scrolling-block {
  display: flex;
  align-items: center;
  overflow-x: hidden;
}

.block-container {
  white-space: nowrap;
  overflow-x: hidden;
  display: flex;
  align-items: flex-end;
  flex-grow: 1;
}
.spec-button {
  cursor: pointer;
  display: block;
  height: 36px;
  line-height: 36px;
  background: #CCC;
  padding-left: 3px;
  padding-right: 3px;
  color: #5A6268;
  border-radius: 5px;
}
  .spec-button:first-child {
    margin-right: 5px;
  }
  .spec-button:last-child {
    margin-left: 5px;
  } 
  .spec-button:hover {
    background: #cccccc8a;
  }
</style>
